import { Component, Input, NgModule } from '@angular/core';

@Component({
    selector: 'app-order-detail-grid',
    templateUrl: './order-detail-grid.component.html',
    styleUrls: ['./order-detail-grid.component.scss'],
    standalone: false
})
export class OrderDetailGridComponent {

  @Input() DataSource: any[] = [];
  @Input() DataColumns: any[] = [];

  constructor(
	) { }

	ngOnInit(): void {
    
	}

  isVisbleOrderOptimzerChild(item: any) {
		if (item != null && item.column != null && item.column.allowEditing != null && item.column.allowEditing) {
			return item.column.allowEditing;
		}
		return false;
	}

	onRowPreparedChild(e: any): void {  
		e.rowElement.style.height = "100px";  
 	}  

	 unsavedChanges = false;
	 onChildRowPrepared(e) {
		 this.unsavedChanges = true;
		 this.addOrReplace(e.data);
	 }
 
	 changedOrderChildTableRecords: any[] = [];
	 arrIndex = {};
	 addOrReplace(object) {
		 let index = this.arrIndex[object.UniqueId];
		 if (index === undefined) {
			 index = this.changedOrderChildTableRecords.length;
			 this.arrIndex[object.UniqueId] = index;
		 }
		 this.changedOrderChildTableRecords[index] = {};
		 this.changedOrderChildTableRecords[index].UniqueId = object.UniqueId;
		 this.DataColumns.forEach(item => {
			 if (item != null && item.IsEditable) {
				 this.changedOrderChildTableRecords[index][item.FieldName] = object[item.FieldName];
			 }
		 });


		 
	 }

}

 
import { CommonModule } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular';
@NgModule({
  declarations: [OrderDetailGridComponent],
  exports: [OrderDetailGridComponent],
  imports: [CommonModule,DxDataGridModule]
})
export class OrderDetailGridModule { }
